// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"c877c35c","592":"4c5a2ab5"}[chunkId] + ".chunk.js";
};